import React from 'react';

import {
  StoreStatus as StoreStatusIcon,
  StoreStatusPreOrder as StoreStatusPreOrderIcon,
} from '../../../components/icons';

export const isRestaurantClosedWithNoPreOrders = (restaurant): boolean =>
  !restaurant.IsOpen && !restaurant.AcceptPreOrders;

export const renderAvailabilityStatusIcon = (restaurant): JSX.Element => {
  if (restaurant.IsOpen) {
    return <StoreStatusIcon testId="open-icon" status="open" size="xs" />;
  } else if (isRestaurantClosedWithNoPreOrders(restaurant)) {
    return <StoreStatusIcon testId="close-icon" status="closed" size="xs" />;
  }

  return <StoreStatusPreOrderIcon testId="preorder-icon" size="xs" />;
};
